// extracted by mini-css-extract-plugin
module.exports = {"modalDiv":"teacher-authenticate_modalDiv__2NXdY"};